/**
 * Usage:
 *
 * data-sw-product-slideshow=<productSpin>
 *
 */

var $ = require('./../sw-jquery');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-product-slideshow]').each(function() {
    var $el = $(this);

    require(['js/lib/models/ModelManager'], function(ModelManager) {

      var spin = $el.data('swProductSlideshow');
      var url = $el.attr('data-sw-product-slideshow-fragment-url');

      var product = ModelManager.getProduct(spin);

      var options = {
        product: product,
        url: url
      };

      if ($el.data('swProductSlideshowKeyboardEvents')) {
        options.keyboardEvents = true;
      }

      $el.slideshow(5, options);
      $el.swSlideshowListener(options);

    });

  });

};
